import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { App } from '@df/core/app';
import { NCore } from '@df/core/df-core.interfaces';
import { Acl } from '@df/core/service/acl';
import { Client } from '@df/core/service/client';
import { NDfDomGlobals, WINDOW } from '@df/dom/globals';
import { TimeoutService } from '@df/ng/timeout.service';

@Injectable({
    providedIn: 'root'
})
export class LocalClient extends Client {
    isCpc = false;

    constructor(
        app: App,
        timeoutService: TimeoutService,
        acl: Acl,
        @Inject(NCore.OPTIONS) moduleConfig: NCore.IModuleOptions,
        @Inject(DOCUMENT) documentRef: Document,
        @Inject(WINDOW) window: NDfDomGlobals.Window
    ) {
        super(app, timeoutService, acl, moduleConfig, documentRef, window);
        if (typeof window !== 'undefined') {
            const queryParams = new URLSearchParams(window?.location?.search);
            this.isCpc =
                queryParams.has('gclid') || queryParams.has('fbclid') || !!queryParams.get('utm_medium')?.match(/.*(cpc|google).*/);
        }
    }
}

